import { render, staticRenderFns } from "./DocumentAttestationTransport.vue?vue&type=template&id=329a8fca&scoped=true"
import script from "./DocumentAttestationTransport.vue?vue&type=script&lang=js"
export * from "./DocumentAttestationTransport.vue?vue&type=script&lang=js"
import style0 from "./DocumentAttestationTransport.vue?vue&type=style&index=0&id=329a8fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a8fca",
  null
  
)

export default component.exports